export const setAuthLocalStorageItems = (accountType,active,token) => {
  localStorage.setItem(`accountType`,accountType)
  localStorage.setItem(`active`,active)
  localStorage.setItem(`token`,token)
  const expirationDate = new Date(new Date().getTime() + 3600000)
  localStorage.setItem(`expirationDate`,expirationDate.toString())
}
